import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SuccessModalComponent } from './success-modal.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [SuccessModalComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  exports: [SuccessModalComponent],
})
export class SuccessModalModule {}
